// @flow
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import style from './ButtonGreyBox.scss';
import buttonStyle from '../../assets/styles/button.scss';

import type { Node } from 'react';

type Props = {
  buttonIntl: string;
  disabled?: boolean;
  handleClick: (e: Event) => void;
  children: Node;
};

export default class ButtonGreyBox extends Component<Props> {
  render() {
    const { buttonIntl, disabled, handleClick, children } = this.props;
    return (
      <div className={style.finalPriceWrap}>
        <Fragment>
          {children}
          <FormattedMessage id={buttonIntl}>{
            txt => <button disabled={disabled}
                           onClick={handleClick}
                           className={classNames(buttonStyle.btn, buttonStyle.lightBlue, style.pay)}>{txt}</button>
          }</FormattedMessage>
        </Fragment>
      </div>
    );
  }
}

ButtonGreyBox.propTypes = {
  buttonIntl: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/ButtonGreyBox/ButtonGreyBox.jsx